<template>
	<div class="star">
		<div
		 :class="starClassName"
		 :style="style"
		></div>
	</div>
</template>

<script>
export default {
	props: {
		precent: {
			type: String,
			default: 0,
			required: true
		},
		starClassName:{
			type: String,
			default: 'yellow'
		}
	},
	computed: {
		style() {
			return {
				width: `${this.precent}%`
			};
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.star {
	@include square(20);
	background: {
		image: url("~@/assets/images/index/star_none.png");
		position: left center;
		size: 100% 100%;
		repeat: no-repeat;
	}
	.yellow {
		height: 100%;
		overflow: hidden;
		background: {
			image: url("~@/assets/images/index/star_yellow.png");
			position: left center;
			size: auto 100%;
			repeat: no-repeat;
		}
	}
	.red{
		@extend .yellow;
		background-image: url("~@/assets/images/index/star_red.png");
	}
	.gray{
		@extend .yellow;
		background-image: url("~@/assets/images/index/star_gray.png");
	}
}
</style>
